<template>
  <v-card outlined style="border-radius: 16px">
    <v-card-text>

      <div style="height: 100%">
        <v-row class="pa-4">
          <v-col cols="12" class="d-flex align-center justify-space-between pa-0">
            <div>
              <app-title>Lista de Sessões</app-title>
            </div>

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="px-0">
              <div>
                <v-card outlined style="border-radius: 16px">
                  <v-card-text>
                    <v-date-picker v-model="focus" :full-width="true" no-title :events="daysWithEvents"
                      event-color="primary" @update:picker-date="handleMonthPickerChange($event)"
                      @input="handleDatePickerChange($event)" />
                  </v-card-text>
                </v-card>
              </div>

              <div class="mt-4">
                <SessionCalendarSideFilter :professionals="professionals" :offices="officesArr" :tags="tags"
                  :showProfessionalsList="showProfessionalsList" :hasTags="hasTags" :hasOffices="hasOffices"
                  v-model="searchParams" />
              </div>
            </div>
          </v-col>
          <v-col cols="9">
            <v-card outlined style="border-radius: 16px">
              <v-card-text>
                <v-row>
                  <v-col class="pa-0 pa-md-3" cols="12" md="12">
                    <template v-for="(session, index) in sessions">
                      <v-hover v-slot="{ hover }" :key="`session-${index}`">
                        <v-alert style="cursor: pointer" border="left" colored-border dense :elevation="hover ? 12 : 0"
                          :class="{ 'on-hover': hover }" :color="session.color">

                          <div class="d-flex align-center justify-space-between">
                            <div>

                              <div>
                                <b class="mr-md-auto">
                                  {{ geCustomerName(session) }}
                                  <template v-if="session.is_online_session">
                                    <v-icon color="primary"> mdi-video </v-icon>
                                  </template>
                                </b>

                              </div>
                              <div>
                                <app-icon class="mr-2" small>badge</app-icon>
                                <small class="mr-auto">{{ session.professional.name }}</small>
                              </div>


                              <div v-if="session.office">
                                <app-icon class="mr-2" small>meeting_room</app-icon>
                                <small class="mr-auto">{{ session.office.name }}</small>

                                <!-- <v-row>
                                  <v-col class="align-center">
                                    <app-icon class="mr-4">meeting_room</app-icon>
                                    <span class="font-weight-bold secondary--text">
                                      {{ session.office.name }}
                                    </span>
                                    <OfficeSearch ref="OfficeSearch" class="d-none" v-model="session.office"
                                      @input="updateSession()" />
                                    <v-btn class="ml-2" icon small color="primary" @click="handleEditOffice">
                                      <app-icon small>mdi-pencil</app-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row> -->
                              </div>

                              <div class="d-flex align-center">
                                <template v-if="showDate">
                                  <app-icon class="mr-2" small>event</app-icon>
                                  <small class="mr-4">
                                    {{ $format.dateBr(session.start_at_date) }}
                                  </small>
                                </template>

                                <app-icon class="mr-2" small>schedule</app-icon>
                                <small>
                                  {{ $format.time(session.start_at_time) }} -
                                  {{ $format.time(session.end_at_time) }}
                                </small>
                              </div>
                              <small v-if="session.booking_id">
                                <v-icon small left> mdi-tooltip-account </v-icon>
                                Agendado pelo App
                              </small>
                            </div>
                            <div>
                              <v-btn @click.stop="handleWhatsAppSendLink(session)" icon>
                                <v-icon color="success">mdi-whatsapp</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </v-alert>
                      </v-hover>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import SessionCalendarSideFilter from "@/components/schedule/sections/SessionCalendarSideFilter.vue";
import DocumentMixin from "@/mixins/Document/DocumentMixin";

import {
  format,
  parse,
  lastDayOfMonth,
  startOfMonth,
} from "date-fns";

export default {

  components: {
    SessionCalendarSideFilter
  },


  mixins: [DocumentMixin],


  data: () => ({
    searchParams: {
      start_date: null,
      end_date: null,
      professionals: [],
      offices: [],
      tags: [],
      status: 'pending',
      session_type: 'session',
    },

    miniCalendarActiveMonth: null,
    daysWithEvents: [],
    sessions: [],
    fetchTimeout: null,
    professionals: [],
    focus: format(new Date(), "yyyy-MM-dd"),
  }),

  computed: {

    showDate() {
      let today = format(new Date(), "yyyy-MM-dd");
      return this.searchParams.start_date == this.searchParams.end_date && this.searchParams.start_date != today;
    },

    isClinic() {
      return this.$store.state.auth.company.type == "clinic";
    },

    user() {
      return this.$store.state.auth.user;
    },

    offices() {
      return this.$store.state.office.offices;
    },

    tags() {
      return this.$store.state.tags.tags;
    },

    company() {
      return this.$store.state.auth.company;
    },

    showProfessionalsList() {
      return this.isClinic && this.$acl.can("can_manage_all_calendar");
    },

    hasTags() {
      return this.tags.length > 0;
    },

    hasOffices() {
      return this.offices.length > 0;
    },

    officesArr() {
      return this.offices.length > 0
        ? [{ id: 0, name: "Sem Sala" }, ...this.offices]
        : [];
    },

  },

  mounted() {
    this.selectProfessionals();
    this.miniCalendarActiveMonth = format(new Date(), "yyyy-MM");
    this.searchParams.start_date = format(new Date(), "yyyy-MM-dd");
    this.searchParams.end_date = format(new Date(), "yyyy-MM-dd");
  },

  beforeDestroy() {
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }
  },

  watch: {
    professionals() {
      this.setSearchParams();
    },

    offices() {
      this.setSearchParams();
    },

    tags() {
      this.setSearchParams();
    },

    searchParams: {
      deep: true,
      handler() {
        this.debouncedFetchSessions();
      },
    },

    miniCalendarActiveMonth() {
      this.selectDaysWithSessions();
    },
  },

  methods: {
    debouncedFetchSessions() {
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout);
      }
      this.fetchTimeout = setTimeout(() => {
        this.fetchSessions();
        this.selectDaysWithSessions();
      }, 300);
    },

    handleEventUpdate() {
      this.fetchSessions();
      this.selectDaysWithSessions();
    },

    fetchSessions() {
      this.$loading.start();
      this.$http
        .index("sessions/calendar", this.searchParams)
        .then((response) => {
          this.sessions = response.sessions;
        })
        .catch(() => {
          this.$notifier.error("Erro ao carregar sessões");
        })
        .finally(() => {
          this.$loading.finish();
        });
    },

    selectProfessionals() {
      if (this.isClinic && this.$acl.can("can_manage_all_calendar")) {
        this.$http
          .index("user/users", {
            is_professional: 1,
            status: "active",
            page: 1,
          })
          .then((response) => {
            this.professionals = response.users.data;
            this.setSearchParams();
          });
      } else {
        this.professionals = [this.user];
        this.searchParams.professionals = [this.user.id];
        this.setSearchParams();
      }
    },

    selectDaysWithSessions() {
      if (!this.miniCalendarActiveMonth) {
        return;
      }

      let month = parse(this.miniCalendarActiveMonth, "yyyy-MM", new Date());
      let params = {
        start: format(startOfMonth(month), "yyyy-MM-dd"),
        end: format(lastDayOfMonth(month), "yyyy-MM-dd"),
        professionals: this.searchParams.professionals,
        offices: this.searchParams.offices,
        tags: this.searchParams.tags,
      };

      this.$http
        .index("sessions/days-with-session", params)
        .then((response) => {
          this.daysWithEvents = response.days;
        })
        .catch((error) => {
          this.$notifier.error("Erro ao carregar dias com sessões");
        });
    },

    setSearchParams() {
      this.searchParams.professionals = this.professionals.map(
        (professional) => professional.id
      );

      this.searchParams.offices = this.officesArr.map((office) => office.id);
    },

    handleDatePickerChange(date) {
      this.searchParams.start_date = date;
      this.searchParams.end_date = date;
    },

    handleMonthPickerChange(month) {
      this.miniCalendarActiveMonth = month;
      this.selectDaysWithSessions();
    },

    handleWhatsAppSendLink(session) {
      let message = this.company.session_reminder_message;
      message = this.parseCommon(message);

      message = this.parseCustomer(message, session.customer);

      message = this.parseProfessional(message, session.professional);

      message = this.parseSession(message, session);

      let phone_wa = null

      phone_wa = session.customer.phone_wa;

      if (session.booking_id && session.booking.phone_wa) {
        phone_wa = session.booking.phone_wa;
      }

      // window.open(`https://wa.me/${phone}?text=${message}`)

      // let link = 'https://web.whatsapp.com/send/?phone=+'

      let link = 'https://wa.me/';
      let msg = '&text=' + encodeURIComponent(message);
      window.open(link + phone_wa + msg, '_blank');
    },

    geCustomerName(session) {
      if (session.booking_id && session.booking) {
        return session.booking.name;
      }
      return session.customer?.name || 'Sem nome';
    }
  }
}
</script>

<style></style>
